/* @flow */
import React from 'react';
import { Root, MetroText, NoWrap } from './styles';
import type { TMetro } from '../../types/apart';
import type { TCity } from '../../types/city';
import MetroIcon from '../MetroIcon/MetroIcon';
import MetroDistance from '../MetroDistance/MetroDistance';
import MetroDistanceKm from '../MetroDistanceKm/MetroDistanceKm';

type TProps = {
	station: TMetro,
	city: TCity,
	cityLink?: string,
	withDistance?: boolean,
	wrapped?: boolean,
	dataQa?: string,
	styles?: any,
};

const MetroName = ({ station, city, withDistance, dataQa, cityLink, wrapped, styles }: TProps) => (
	<Root
		data-qa={dataQa}
		key={station?.id.toString()}
		$wrap={
			withDistance
				? station?.distance || station?.durationWalking || station?.durationTransit || station?.durationDriving
				: undefined
		}
		styles={styles}
	>
		<NoWrap
			$withDistance={
				withDistance
					? station?.distance ||
					  station?.durationWalking ||
					  station?.durationTransit ||
					  station?.durationDriving
					: undefined
			}
		>
			<MetroIcon
				cityLink={cityLink || city?.link}
				station={station}
				color={station?.lineColor}
				alt={station?.lineName}
			/>
			<MetroText>{station?.name}</MetroText>
		</NoWrap>
		{withDistance && (station?.durationWalking || station?.durationTransit || station?.durationDriving) && (
			<MetroDistance
				wrapped={wrapped}
				durationTransit={station?.durationTransit}
				durationDriving={station?.durationDriving}
				durationWalking={station?.durationWalking}
			/>
		)}
		{withDistance &&
			!(station?.durationWalking || station?.durationTransit || station?.durationDriving) &&
			station?.distance && <MetroDistanceKm distance={station?.distance} />}
	</Root>
);

MetroName.defaultProps = {
	withDistance: false,
	wrapped: false,
	cityLink: null,
	dataQa: null,
	styles: undefined,
};

export default MetroName;
